import { FC, useMemo } from 'react';

import { DbtResourceIcon } from '@dbt-labs/dbt-dag';
import { Icon, RyeconGrid } from '@dbt-labs/sourdough';

import { useDbtCloudProject } from '@/context/DbtCloudProjectProvider';
import { useResourceCounts } from '@/hooks/discovery/resourceCounts';
import { useLinkToExplorer } from '@/hooks/links';
import { useUrlProjectParams } from '@/hooks/params';
import { NavButtonGroup, OptionConfig } from '@/panel/NavButton/NavButtonGroup';
import {
  nameMap,
  orderedNavigationResourceTypes,
  useSelectedResourceFilter,
} from './selectedResource';

export const ResourcesFilter: FC = () => {
  const selectedResource = useSelectedResourceFilter();
  const projectScope = useUrlProjectParams();
  const getResourceFilterUrl = useLinkToExplorer('resourceFilter');

  const { environmentId } = useDbtCloudProject();
  const resourceCountsQuery = useResourceCounts({
    environmentId,
  });

  const resourceCounts = resourceCountsQuery.data;

  const options = useMemo(() => {
    const options: OptionConfig<(typeof orderedNavigationResourceTypes)[number]>[] = [];
    const typesToShow = orderedNavigationResourceTypes;
    typesToShow.forEach((resource) => {
      if (resource === 'group') {
        options.push({
          option: resource,
          icon: <Icon className="mx-auto text-current" ryecon={RyeconGrid} />,
          // Do not show `0` as a value
          count: resourceCounts?.groups || undefined,
          label: nameMap[resource],
        });
      } else {
        options.push({
          option: resource,
          icon: (
            <DbtResourceIcon
              className="mx-auto text-current"
              resource={resource}
              testId={`${resource}-filter-icon`}
            />
          ),
          // Do not show `0` as a value
          count: resourceCounts?.[resource] || undefined,
          label: nameMap[resource],
        });
      }
    });
    return options;
  }, [resourceCounts]);

  return (
    <>
      <NavButtonGroup
        currentOption={selectedResource}
        options={options}
        getTargetUrl={(option) =>
          getResourceFilterUrl({
            ...projectScope,
            resourceType: option,
          })
        }
      />
    </>
  );
};
